import * as React from "react"
import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { DateInput } from "@/components/ui/date-input"

type FollowupDateControlProps = {
  readonly replyId: number
  readonly nextFollowupOn: string | null
  readonly id: string
}

export function FollowupDateControl({ replyId, nextFollowupOn, id }: FollowupDateControlProps) {
  const [value, setValue] = React.useState(nextFollowupOn ?? "")

  // Re-sync when the server changes the date under us. Inertia POSTs preserve
  // React state, so without this the input keeps its old value while the prop
  // moves on (e.g. "Mark responded" schedules +3 days) — which flips `dirty`
  // true and lets Save write the stale value back, silently wiping the new
  // follow-up date that Today's FOLLOW-UP DUE bucket depends on.
  React.useEffect(() => {
    setValue(nextFollowupOn ?? "")
  }, [nextFollowupOn])

  const dirty = value !== (nextFollowupOn ?? "")

  const save = () => {
    if (!dirty) return

    router.post(`/replies/${replyId}/followup_date`, { next_followup_on: value }, { preserveScroll: true })
  }

  return (
    <div className="flex items-end gap-2">
      <label htmlFor={id} className="flex-1">
        Follow up
        <DateInput id={id} value={value} onChange={(event) => setValue(event.target.value)} />
      </label>
      <Button type="button" variant="secondary" size="sm" disabled={!dirty} onClick={save}>
        Save
      </Button>
    </div>
  )
}
